import { useEffect } from "react";
import { SITE_URL } from "../lib/api";

export default function Seo({ title, description, path, jsonLd, noindex, image }) {
  useEffect(() => {
    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    if (title) document.title = title;
    if (title) setMeta("property", "og:title", title);
    let meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    if (description) setMeta("property", "og:description", description);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", image);
    }
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${path || window.location.pathname}`);
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
    let script;
    if (jsonLd) {
      const old = document.getElementById("page-jsonld");
      if (old) old.remove();
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById("page-jsonld");
      if (el) el.remove();
    };
  }, [title, description, path, jsonLd, noindex, image]);
  return null;
}
